var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-show main-container"},[_c('div',{staticClass:"message-box"},[_c('h1',{staticClass:"center"},[_vm._v("联系我们")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.info)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }